// extracted by mini-css-extract-plugin
export default {"select":"budget-controls_select__vhNDx"};